import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const pages = {
  privacy: {
    title: "Privacy Policy",
    body: `Questa pagina è una bozza sostitutiva. Il titolare del trattamento dei dati è Giovanna Matino Interior Design Studio (P.IVA 09203521217), con sede in Via Carmine Guadagno 160, 80038 Pomigliano d'Arco (NA).

I dati personali raccolti tramite i form del sito (contatti, prenotazione, newsletter, checkout) sono utilizzati esclusivamente per rispondere alle richieste, gestire le prenotazioni e — con consenso esplicito — inviare comunicazioni commerciali. I dati non vengono ceduti a terzi al di fuori dei fornitori tecnici strettamente necessari (hosting, provider email, gateway di pagamento).

L'utente ha diritto di accesso, rettifica, cancellazione e portabilità dei propri dati ai sensi del GDPR (Reg. UE 2016/679). Per esercitare questi diritti scrivere a giovannamatinointerior@gmail.com.

⚠️ IMPORTANTE — TESTO PROVVISORIO. Prima della messa online reale del sito, questa informativa deve essere sostituita con testo definitivo redatto o validato da un professionista legale. Il testo attuale è una traccia strutturale e non ha valore legale.`,
  },
  cookie: {
    title: "Cookie Policy",
    body: `Il sito utilizza le seguenti categorie di cookie:

• Cookie tecnici (necessari) — permettono il corretto funzionamento del sito, la sessione utente e il carrello. Non richiedono consenso.
• Cookie analitici — utilizzati per raccogliere informazioni aggregate sull'utilizzo del sito. Richiedono consenso esplicito.
• Cookie di marketing e re-targeting — utilizzati per proporre contenuti pertinenti. Richiedono consenso esplicito.

Il consenso viene richiesto tramite banner al primo accesso. L'utente può in qualsiasi momento modificare le proprie preferenze eliminando la voce "gm_cookie_consent_v1" dallo storage del browser oppure ricaricando la pagina.

⚠️ IMPORTANTE — TESTO PROVVISORIO. Prima della messa online reale del sito, questa policy deve essere verificata e completata con l'elenco specifico dei cookie effettivamente installati.`,
  },
  termini: {
    title: "Termini e Condizioni",
    body: `Le condizioni di utilizzo del sito e le condizioni contrattuali dei servizi di consulenza (Consulenza Essenza, Atelier, Maison) sono specificate nel preventivo/contratto sottoscritto da ogni cliente al momento dell'incarico.

Le tariffe indicate sul sito ("Da 990 €", "Preventivo personalizzato", "Preventivo su misura") sono indicazioni orientative e non costituiscono offerta contrattuale. L'importo definitivo viene comunicato a Giovanna Matino previa analisi dell'immobile e delle esigenze del cliente.

⚠️ IMPORTANTE — TESTO PROVVISORIO. Prima della messa online reale del sito, questi Termini devono essere sostituiti con testo definitivo redatto o validato da un professionista legale.`,
  },
};

export default function LegalPage({ slug }) {
  const p = pages[slug];
  const [custom, setCustom] = useState(null);
  useEffect(() => {
    // Contenuto personalizzato pubblicato dalla dashboard (se esiste)
    setCustom(null);
    api.get(`/pages/${slug}`).then((r) => setCustom(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, [slug]);
  if (!p) return null;
  const title = custom?.title || p.title;
  return (
    <div className="container-x py-16 max-w-3xl" data-testid={`page-legal-${slug}`}>
      <Link to="/" className="text-xs tracking-[0.14em] uppercase text-taupe hover:text-ink">← Home</Link>
      <h1 className="font-serif text-4xl md:text-6xl mt-6">{title}</h1>
      {custom ? (
        <div className="mt-8 text-taupe leading-[1.9] font-light [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-ink [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-serif [&_h3]:text-xl [&_h3]:text-ink [&_h3]:mt-8 [&_h3]:mb-2 [&_p]:mb-4 [&_a]:text-gold [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4"
          dangerouslySetInnerHTML={{ __html: custom.content_html }} data-testid="legal-custom-content" />
      ) : (
        <div className="mt-8 whitespace-pre-wrap text-taupe leading-[1.9] font-light">{p.body}</div>
      )}
      <div className="mt-12 border-t border-hair pt-6 text-xs text-taupe">
        Aggiornata il {new Date(custom?.updated_at || Date.now()).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })} · Giovanna Matino Interior · P.IVA 09203521217
      </div>
    </div>
  );
}
